'use client'

import classNames from 'clsx'
import { useTranslations } from 'next-intl'

import TrophyIcon from '@/assets/icons/athlete-trophy.svg'
import ShieldIcon from '@/assets/icons/leaderboard/lb-icon-shield.svg'
import UsersIcon from '@/assets/icons/leaderboard/lb-icon-users.svg'

import S from './FansClubsToggle.module.scss'

export type LeaderboardAudience = 'fans' | 'clubs' | 'athletes'

type FansClubsToggleProps = {
  value: LeaderboardAudience
  onChange: (value: LeaderboardAudience) => void
  /** BAT-1110: the «Athletes» tab, behind the athlete feature flag. */
  withAthletes?: boolean
}

const SEGMENTS = [
  { id: 'fans', Icon: UsersIcon },
  { id: 'clubs', Icon: ShieldIcon },
  { id: 'athletes', Icon: TrophyIcon }
] as const

export default function FansClubsToggle({
  value,
  onChange,
  withAthletes = false
}: FansClubsToggleProps) {
  const t = useTranslations('fansLeaderboard')

  return (
    <div className={S.toggle} role="tablist">
      {SEGMENTS.filter(({ id }) => withAthletes || id !== 'athletes').map(
        ({ id, Icon }) => {
          const active = value === id
          return (
            <button
              key={id}
              type="button"
              role="tab"
              aria-selected={active}
              className={classNames(S.segment, active && S.segmentActive)}
              onClick={() => !active && onChange(id)}
            >
              <Icon className={S.icon} aria-hidden />
              {t(`toggle.${id}`)}
            </button>
          )
        }
      )}
    </div>
  )
}
